// extracted by mini-css-extract-plugin
module.exports = {"iconsColorToggle":"EditableImage_iconsColorToggle__1u2j0"};